import { LBtn } from "@components";
import { useModal } from "@services/ModalContext";
import classNames from "classnames";

export const LModalFooterButtons = ({
    loading,
    centered,
    cancelText = "Cancel",
    confirmText = "Confirm"
}: ExistingFooterProps): JSX.Element => {
    const { formName, closeModal } = useModal();

    const classes = classNames(
        "is-flex",
        "is-flex-direction-row",
        centered ? "is-justify-content-center" : "is-justify-content-space-between"
    );

    return (
        <div className={classes}>
            <LBtn variation="unstyled" onClick={closeModal} isBold>
                {cancelText}
            </LBtn>
            <LBtn type="submit" form={formName} isBold loading={loading}>
                {confirmText}
            </LBtn>
        </div>
    );
};

interface ExistingFooterProps {
    loading?: boolean;
    centered?: boolean;
    cancelText?: string;
    confirmText?: string;
}
